export default "__VITE_ASSET__BvYjwGuQ__"